import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNearmehelp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.083 6.118 3.79 10.758l4.729 1.328c.089.025.258.076.443.176.413.224.752.563.976.976.1.186.151.354.176.444l1.327 4.728.267-.706a6 6 0 0 0 1.064 1.428l-.556 1.473c-.282.747-1.305.798-1.671.113a.7.7 0 0 1-.052-.134L8.67 14.087a.7.7 0 0 0-.051-.135.9.9 0 0 0-.371-.37.7.7 0 0 0-.135-.052l-6.496-1.823a.7.7 0 0 1-.135-.052c-.685-.365-.634-1.389.114-1.67l15.156-5.723a.92.92 0 0 1 1.187 1.186L16.64 8.885a6 6 0 0 0-1.742.367z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.167 18.085A5 5 0 0 1 12 14.874a4.997 4.997 0 0 1 5-5 5 5 0 1 1-3.833 8.211m3.845-2.087c-.255 0-.466-.208-.443-.462q.028-.302.098-.474.116-.285.494-.622.329-.288.501-.502a.75.75 0 0 0 .173-.485.73.73 0 0 0-.22-.546q-.222-.217-.615-.217-.41 0-.622.25-.088.102-.155.207c-.097.151-.287.238-.452.167-.295-.126-.452-.465-.265-.726q.15-.21.362-.387.45-.378 1.132-.378.843 0 1.296.47t.454 1.128a1.3 1.3 0 0 1-.173.686 3.5 3.5 0 0 1-.541.646q-.394.378-.478.574a1 1 0 0 0-.055.21c-.04.252-.236.46-.491.46M17 17.924a.62.62 0 0 1-.454-.189.62.62 0 0 1-.188-.453q0-.265.188-.454A.62.62 0 0 1 17 16.64q.265 0 .454.188a.62.62 0 0 1 .188.454.62.62 0 0 1-.188.453.62.62 0 0 1-.454.19",
    clipRule: "evenodd"
  }));
}
var IcNearmehelp = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNearmehelp));

export { IcNearmehelp as I };
